import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon XIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const XIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path d="M11.57 10l8.1-8.1a1.1 1.1 0 000-1.57 1.1 1.1 0 00-1.57 0L10 8.43 1.9.33a1.1 1.1 0 00-1.57 0 1.1 1.1 0 000 1.57l8.1 8.1-8.1 8.1a1.1 1.1 0 000 1.57 1.08 1.08 0 00.78.33 1.11 1.11 0 00.79-.33l8.1-8.1 8.1 8.1a1.11 1.11 0 00.79.33 1.08 1.08 0 00.78-.33 1.1 1.1 0 000-1.57z" />
    </Icon>
  )
}
export default XIcon
